import { formatCurrency } from '../../utils/currencyUtils';
import OmCard from '../ui/OmCard';

const ClaimsSummaryStats = ({ filteredClaims }) => {
  if (filteredClaims.length === 0) return null;

  const stats = [
    {
      value: filteredClaims.length,
      label: 'Total Claims',
      color: 'border-l-fresh-leaf',
      textColor: 'text-fresh-leaf',
      textSize: 'text-3xl'
    },
    {
      value: filteredClaims.filter(c => c.status === 'APPROVED').length,
      label: 'Approved',
      color: 'border-l-forest-fern',
      textColor: 'text-forest-fern',
      textSize: 'text-3xl'
    },
    {
      value: filteredClaims.filter(c => c.status === 'UNDER_REVIEW').length,
      label: 'Under Review',
      color: 'border-l-zesty-lime',
      textColor: 'text-zesty-lime',
      textSize: 'text-3xl'
    },
    {
      value: formatCurrency(filteredClaims.reduce((sum, claim) => sum + (claim.benefitAmount || 0), 0)),
      label: 'Total Amount',
      color: 'border-l-woodland-moss',
      textColor: 'text-woodland-moss',
      textSize: 'text-2xl'
    }
  ];

  return (
    <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {stats.map((stat, index) => (
        <div key={index} style={{
          '--omk-card-background-colour': '#ffffff',
          '--omk-card-border-radius': '0.5rem',
          '--omk-card-elevation': 'var(--omk-elevation-1)',
          '--omk-card-padding': '1.5rem'
        }}>
          <OmCard className={`border-l-4 ${stat.color}`} style={{ borderRadius: '0.5rem', minHeight: '120px' }}>
            <div className="space-y-2 flex flex-col justify-center h-full">
              <div className={`${stat.textSize} font-bold ${stat.textColor} tracking-tight leading-tight`}>
                {stat.value}
              </div>
              <div className="text-sm font-medium text-steel uppercase tracking-wide">
                {stat.label}
              </div>
            </div>
          </OmCard>
        </div>
      ))}
    </div>
  );
};

export default ClaimsSummaryStats;
